import React, { forwardRef } from 'react';
import { usePress } from 'react-aria';
import { Button, ButtonProps } from '@mui/material';

// A button-like component that allows movement of finger after touch start and before touch end.
export interface TouchButtonProps extends Omit<ButtonProps, 'component'> {
  component?: React.ElementType;
}

export const TouchButton = forwardRef<HTMLElement, TouchButtonProps>((props, ref) => {
  const { component: Component = Button, onClick, children, ...other } = props;

  const { pressProps } = usePress({
    onPress: (e) => {
      onClick?.(e as any);
    },
  });

  return (
    <Component
      {...(other as any)}
      {...pressProps}
      ref={ref as any}
      sx={{ touchAction: 'none', WebkitTapHighlightColor: 'transparent', ...other?.sx }}
    >
      {children}
    </Component>
  );
});